import React, { Component } from 'react'
import './index.css';
import ReactMonacoTree from './components/ReactMonacoTree';

import './assets/main.css';
import './assets/vscode-icons.css';

export default class extends Component {

	// componentWillReceiveProps(nextProps) {
    //     // console.log("index, RMT, CWRP; props, nextProps: ", this.props, nextProps);
        
    //     const newFilePathList = nextProps.filePathList.join();
    //     const oldFilePathList = this.props.filePathList.join();
    //     if (oldFilePathList !== newFilePathList) {
    //         // console.log("index, pathlist updated; newFilePathList, oldFilePathList: ", newFilePathList, oldFilePathList);
    //     }
    // }

	render() {
		// console.log("index, RMT; props: ", this.props);
		return (
			<div
				className="react-monaco-tree-wrapper"
				style={{ width: "100%", height: "100%" }}
			>
				<ReactMonacoTree
					filePathList={this.props.filePathList}
					onFolderTreeFileClick={this.props.onFolderTreeFileClick}
				/>
			</div>
		)
	}
}

// Add PropTypes here!!